import { useDispatch, useSelector, useStore } from "react-redux";

import type { AppDispatch, RootState } from "@/store";

/**
 * Use throughout the app instead of plain `useDispatch`.
 * Gives you a fully typed dispatch that knows about thunks.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/**
 * Use throughout the app instead of plain `useSelector`.
 * Automatically infers the return type from your selector.
 */
export const useAppSelector = useSelector.withTypes<RootState>();

/**
 * Use when you need direct store access (rare — prefer selectors).
 */
export const useAppStore = useStore.withTypes<typeof import("@/store").store>();